import React from "react";
import Container from "../components/wrapper/container.wrapper";
import * as Role from "../modules/role";
import {RoleModuleStoreInterface} from "../types";
import {RoleTranslationRequest} from "../types/request";
import {RouteObject} from "react-router-dom";
import ErrorBoundary from "../components/wrapper/errorBoundary.wrapper";

export const RoleRouter = ({ isAuthenticated, roleStore }: {
    isAuthenticated: () => boolean,
    roleStore:  RoleModuleStoreInterface
}): RouteObject => (
    {
        path: "/",
        element: <Container/>,
        children: [
            {
                path: "/role",
                element: <Role.List />,
                errorElement: <ErrorBoundary hasError={true} />,
            },
            {
                path: "/role/:id/edit",
                element: <Role.Edit />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return roleStore.prepareEditForm({ id: params.id });
                },
            },
            {
                path: "/role/:id/view",
                element: <Role.View />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return roleStore.view({ id: params.id });
                },
            },
            {
                path: "/role/:id/edit_role_accesses",
                element: <Role.Accesses/>,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((resolve, reject) => {
                            reject(null)
                        })
                    }

                    return roleStore.accesses({id: params.id});
                },
                action: async ({params, request}: any) => {
                    let json = await request.formData();
                    return roleStore.editAccesses({id: params.id, ...JSON.parse(json.get('data') as string)});
                }
            },
            {
                path: "/role/:id/edit_entity_translations",
                element: <Role.EntityTranslate />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((resolve, reject) => {
                            reject(null)
                        })
                    }

                    return roleStore.translations({id: params.id});
                },
                action: async ({params, request}: any) => {
                    let json = await request.formData();
                    return roleStore.editTranslations({id: params.id, translations: {...JSON.parse(json.get('data') as string)}} as RoleTranslationRequest );
                }
            }
        ]
    }
)